import { render, staticRenderFns } from "./TransformScriptCodeHilight.vue?vue&type=template&id=dcf3e872&scoped=true"
import script from "./TransformScriptCodeHilight.vue?vue&type=script&lang=ts"
export * from "./TransformScriptCodeHilight.vue?vue&type=script&lang=ts"
import style0 from "./TransformScriptCodeHilight.vue?vue&type=style&index=0&id=dcf3e872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf3e872",
  null
  
)

export default component.exports